import type { ReactNode } from "react";

interface AiShellProps {
  header: ReactNode;
  history: ReactNode;
  artefacts?: ReactNode;
  showArtefacts: boolean;
  mobileHistoryOpen: boolean;
  messages: ReactNode;
  footer: ReactNode;
}

/**
 * Hybrid Ask Insights chrome: history | thread+footer | optional artefacts.
 */
export function AiShell({
  header,
  history,
  artefacts,
  showArtefacts,
  mobileHistoryOpen,
  messages,
  footer,
}: AiShellProps) {
  return (
    <section className="flex h-[calc(100dvh-6.5rem)] flex-col gap-3 px-1 sm:px-0">
      {header}
      {mobileHistoryOpen ? <div className="lg:hidden">{history}</div> : null}
      <div className="flex min-h-0 flex-1 gap-3 lg:gap-4">
        <div className="hidden lg:flex">{history}</div>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <div className="min-h-0 flex-1 overflow-y-auto rounded-soft-md border border-border bg-surface p-3 shadow-rest sm:p-4">
            {messages}
          </div>
          <div className="shrink-0 space-y-2 bg-surface pt-2">{footer}</div>
        </div>
        {showArtefacts ? artefacts : null}
      </div>
    </section>
  );
}
